import CloseIcon from '~/shared/assets/icons/arrow-right.svg';
import DeleteIcon from '~/shared/assets/icons/delete.svg';
import Typography from '~/shared/components/Typography';

import Button from '../ButtonsV2';

interface FilterPanelHeaderProps {
  onClose?: () => void;
  onClearAll?: () => void;
  hasActiveFilters?: boolean;
}

export default function FilterPanelHeader({
  onClose,
  onClearAll,
  hasActiveFilters = false,
}: FilterPanelHeaderProps) {
  return (
    <div className="flex justify-between items-center px-8 py-6">
      <Typography
        variant="H3-med-resp"
        fontWeight={500}
        className="font-family-outfit text-primary-900"
      >
        Filters
      </Typography>
      <div className="flex items-center gap-2.5">
        {onClearAll && (
          <Button
            className="hover:!borderred group px-4 py-2"
            variant="text"
            size="sm"
            leftIcon={
              <DeleteIcon className="size-5 group-hover:textred transition-colors duration-300" />
            }
            onClick={onClearAll}
            disabled={!hasActiveFilters}
            aria-label="Clear all filters"
          >
            <Typography
              variant="buttons-m"
              fontWeight={600}
              className="font-family-inter pt-0.5 text-primary-900"
            >
              Clear all
            </Typography>
          </Button>
        )}
        {onClose && (
          <Button
            size="sm"
            className="w-9"
            variant="third"
            icon={<CloseIcon className="size-5" />}
            onClick={onClose}
          />
        )}
      </div>
    </div>
  );
}
